/*
 *  I15TEMPRELEVEI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-06-17 07:29:56 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15TEMPRELEVE_SECTION_0_TITLE: "Calculez la température en dessous de laquelle l'appoint devient nécessaire",
  I15TEMPRELEVE_I04DIMPUISCONS: 'Calcul Déperdition Selon bilan de consommation',
  I15TEMPRELEVE_I04DIMPUISSCHAUD: 'Calcul Déperdition selon la surface habitable',
  I15TEMPRELEVE_in_deperdition: 'Déperdition à température de base',
  I15TEMPRELEVE_in_temp_consigne: 'Température de consigne',
  I15TEMPRELEVE_in_puissance_chaudiere: 'Puissance chaudière bois',
  I15TEMPRELEVE_in_tempExtBase: 'Température de base ext.',
  I15TEMPRELEVE_res_tempReleveAppoint: "Température de relève de l'appoint",
  I15TEMPRELEVE_res_installationSansAppoint: "Température de relève de l'appoint",
  I15TEMPRELEVE_res_installationSansAppoint2: 'Installation sans appoint'
}
